(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avvio-launch"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.BUTONAvvioPreviewReady)return;
  window.BUTONAvvioPreviewReady=true;
  document.addEventListener('change',function(event){var input=event.target;if(!input.closest('[data-avvio-variant-choices]'))return;var d=input.closest('[data-avvio-detail-dialog]');if(!d)return;var size=d.querySelector('[data-avvio-size] input:checked');var personal=d.querySelector('[data-avvio-personalisation] input:checked');var chosen=personal&&personal.value==='Logo / initials';var price=d.querySelector('[data-avvio-selected-price]');if(price)price.textContent=chosen?'10 990':'8 990';var summary=d.querySelector('[data-avvio-summary]');if(summary)summary.textContent=(size?size.value.toUpperCase():'36 MM')+' / '+(chosen?'LOGO / INITIALS':'STANDARD');var note=d.querySelector('[data-avvio-personal-note]');if(note)note.hidden=!chosen;});
  document.addEventListener('click',function(event){
    var trigger=event.target.closest('[data-avvio-detail-open]');
    if(trigger){
      var detail=document.getElementById(trigger.getAttribute('data-avvio-detail-open'));
      if(detail){
        if(typeof detail.showModal==='function'){if(!detail.open)detail.showModal();}
        else detail.setAttribute('open','');
      }
      return;
    }
    var closeDetail=event.target.closest('[data-avvio-detail-close]');
    if(closeDetail){
      var openDetail=closeDetail.closest('[data-avvio-detail-dialog]');
      if(openDetail){if(typeof openDetail.close==='function')openDetail.close();else openDetail.removeAttribute('open');}
      return;
    }
    var buy=event.target.closest('[data-avvio-preview-open]');
    if(buy){
      var detailDialog=buy.closest('[data-avvio-detail-dialog]');
      if(detailDialog){
        var notice=detailDialog.querySelector('[data-avvio-detail-alert]');
        if(notice){notice.hidden=false;notice.focus({preventScroll:false});}
        return;
      }
      var root=buy.closest('.avvio-maison');
      var panel=root&&root.querySelector('[data-avvio-preview-dialog]');
      if(panel){
        if(typeof panel.showModal==='function'){if(!panel.open)panel.showModal();}
        else panel.setAttribute('open','');
      }
      return;
    }
    var closer=event.target.closest('[data-avvio-preview-close]');
    if(closer){
      var preview=closer.closest('dialog');
      if(preview){if(typeof preview.close==='function')preview.close();else preview.removeAttribute('open');}
    }
  });
  document.addEventListener('click',function(event){
    if(event.target.matches('[data-avvio-detail-dialog]')){
      var dialog=event.target;
      if(typeof dialog.close==='function')dialog.close();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
